module.exports = __webpack_public_path__ + "static/media/watch.e8078a51.svg";